module.exports = __webpack_public_path__ + "img/Koios_black.60759ae1.png";